enum NegotiationPosition {
  NOT_PART = 0,
  IS_DEALER = 1,
  IS_TOP_BIDDER = 2,
  IS_SECOND_BIDDER = 3
}

export default NegotiationPosition;
